import InputRating, { CustomInputRatingProps } from './InputRating.component';

export type InputRatingProps = CustomInputRatingProps;

export default InputRating;
